import React from "react"
import styled from "styled-components"

import { Box } from "components/box"
import { Paragraph, ParagraphLarge } from "components/text"

const NotificationContainer = styled(Box).attrs({
  p: [4, 4, 5, 5],
  mt: [4, 4, 6, 6],
  mb: [5, 5, 7, 7]
})`
  text-align: left;
  background-color: ${props => props.theme.colors.sandy};
  color: ${props => props.theme.colors.evergreen};
`

export const Notification: React.FC<{ title: React.ReactNode; description: React.ReactNode; dataTest?: string }> = ({
  title,
  description,
  dataTest
}) => (
  <NotificationContainer data-test={dataTest}>
    <ParagraphLarge mb={3} bold>
      {title}
    </ParagraphLarge>
    <Paragraph>{description}</Paragraph>
  </NotificationContainer>
)

export default Notification
